import { BusinessError } from '@/error';
import { pStore } from '@/pinia';
import vuexStore from '@/vuex-store';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { openPopup } from '@/utils/popup';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { routeName } from '@/constants/routeName';
import { popupIdData } from '@/constants/popupIdData';
import { getRouterUrl } from '@/utils/url';
/**
 * Composable: 라이더 배차
 */
export const useWorkerAllocate = () => {
    const pWorkerAllocateDialog = pStore.piniaWorkerAllocate;
    const popup = popupIdData[routeName.WORKER_ALLOCATE];
    const route = useRoute();
    const { hubList, distId, hubId, orderId, selectedOrder, fulfillment, isDialogOpen, selectedWorker, filterOption, } = storeToRefs(pWorkerAllocateDialog);
    /**
     * 주문 조회
     */
    const getOrder = async () => {
        await pWorkerAllocateDialog.getOrder();
    };
    /*
     * query string을 pinia에 주입
     */
    const injectQSToPinia = async () => {
        const _distId = route.query.distId;
        const _hubId = route.query.hubId;
        const _orderId = route.query.orderId;
        if (_distId) {
            await pWorkerAllocateDialog.setPopupData({
                distId: _distId,
                hubId: _hubId,
                orderId: _orderId,
            });
            return true;
        }
        return false;
    };
    const openWorkerAllocateDialog = () => {
        isDialogOpen.value = true;
    };
    /**
     * 배차 요청 버튼 비활성화 여부
     * 공유라이더는 배요가 불가하다
     * https://barogo.atlassian.net/browse/QA-2362
     */
    const isRequestAllocateDisabled = computed(() => {
        // 선택되지 않았으면 비활성
        if (!selectedWorker.value) {
            return true;
        }
        // 공유라이더먼 비활성
        if (selectedWorker.value?.isShareWorker(hubId.value)) {
            return true;
        }
        // 그 외 활성
        return false;
    });
    /**
     * 배차 다이얼로그 팝업 열기
     * 내부에서 열 때는 인자를 사용하고 외부에서 열 때는 url의 query string을 사용할 예정
     * @param _orderId 선택한 주문의 아이디
     * @param _distId 총판 아이디
     * @param _hubId 허브 아이디 (허브 아이디 없으면 총판 조회)
  
    /**
     * 닫기 버튼 숨기기 여부 체크
     */
    const checkIsHideCloseBtn = computed(() => {
        // 팝업이면 숨기지 않음
        if (window.opener) {
            return false;
        }
        // 본창이면 숨김
        return true;
    });
    /**
     * 허브 리스트 조회
     */
    const getHubList = async () => {
        try {
            const optionsModel = {};
            // 최상위 전체 항목 추가
            optionsModel.ALL = {
                key: 'ALL',
                text: '전체',
                value: {
                    type: 'HUB',
                    id: 'ALL',
                    hubId: 'ALL',
                    hubName: '전체',
                },
            };
            fulfillment.value?.forEach((item) => {
                if (optionsModel[item.hubId]) {
                    return;
                }
                optionsModel[item.hubId] = {
                    key: item.hubId,
                    text: item.hubName,
                    value: {
                        type: 'HUB',
                        id: item.hubId,
                        hubId: item.hubId,
                        hubName: item.hubName,
                    },
                };
            });
            filterOption.value.selectedHub = optionsModel.ALL.value;
            hubList.value = Object.values(optionsModel);
        }
        catch (error) {
            if (error instanceof BusinessError) {
                vuexStore.dispatch(snackbarActionType.showError, error.message);
            }
            hubList.value = [];
        }
    };
    /**
     * 풀필먼트 조회
     */
    const getFulfillment = async () => {
        await pWorkerAllocateDialog.getFulfillment();
        getHubList();
    };
    /**
     * 배차 다이얼로그 팝업 열기
     * 내부에서 열 때는 인자를 사용하고 외부에서 열 때는 url의 query string을 사용할 예정
     * @param _orderId 선택한 주문의 아이디
     * @param _distId 총판 아이디
     * @param _hubId 허브 아이디 (허브 아이디 없으면 총판 조회)
     */
    const handleClickOpenWorkerAllocateDialog = (_distId = '', _hubId = '') => {
        // 팝업 열려 있으면 신규 생성하지 않고 주문 변경 실행
        if (window[popup.id]
            && !window[popup.id].closed) {
            // 메서드 실행
            window[popup.id].changeWorkerAllocateOrder && window[popup.id].changeWorkerAllocateOrder(_distId, _hubId, orderId.value);
            return;
        }
        const url = getRouterUrl({
            routeName: routeName.WORKER_ALLOCATE,
            query: {
                orderId: orderId.value,
                distId: _distId,
                hubId: _hubId,
            },
        }).toString();
        window[popup.id] = openPopup(url, popup);
    };
    return {
        isRequestAllocateDisabled,
        selectedOrder,
        orderId,
        distId,
        hubId,
        popup,
        popupId: popup.id,
        fulfillment,
        injectQSToPinia,
        getOrder,
        getFulfillment,
        isDialogOpen,
        selectedWorker,
        openWorkerAllocateDialog,
        checkIsHideCloseBtn,
        getHubList,
        hubList,
        filterOption,
        handleClickOpenWorkerAllocateDialog,
    };
};
